import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit, HostBinding } from '@angular/core';
import { PermissionRoute, UserPermission } from 'app/interfaces/permission';
import { SharedDataService } from 'app/services/shared-data.service';
import { PermissionsService } from 'app/services/permissions.service'
import { NegotiationComponent } from 'app/negotiation/negotiation.component';

import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment'
import { AuthService } from 'app/services/auth.service';
// Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    collapse?: string;
    target?: string;
    icontype: string;
    showInProduction?: boolean;
    role: string[];
    hasPermission?: boolean;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    hasPermission?: boolean;
    permissionRef?: string
    routeRef?: string
}

// Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'nc-icon nc-bank',
        role: ['Admin', 'VENDEDOR']
    },
    {
        path: '/comercial',
        title: 'Comercial',
        type: 'sub',
        collapse: 'comercial',
        target: 'sales',
        icontype: 'nc-icon nc-delivery-fast',
        role: ['Admin', 'VENDEDOR'],
        children: [
            {path: '/simulations/list', title: 'Simulações', ab: 'S', routeRef: 'simulation', permissionRef: 'list'},
            {path: '/order/list', title: 'Pedidos', ab: 'P',  routeRef: 'order', permissionRef: 'list'},
            {path: '/invoice/list', title: 'Notas Fiscais', ab: 'NF',  routeRef: 'invoice', permissionRef: 'list'},
            {path: '/negotiation/list', title: 'Negociação', ab: 'N',  routeRef: 'trade', permissionRef: 'list'},
            {path: '/negotiation-trade/list', title: 'Negociação - Trade', ab: 'NT',  routeRef: 'trade', permissionRef: 'list'},

        ]
    },
    {
        path: '/cadastros',
        title: 'Cadastros',
        type: 'sub',
        collapse: 'cadastros',
        target: 'register',
        icontype: 'nc-icon nc-badge',
        role: ['Admin', 'VENDEDOR'],
        children: [
            {path: '/customer/list', title: 'Clientes', ab: 'C',  routeRef: 'customer', permissionRef: 'list'},
            {path: '/reembolso', title: 'Reembolso de Despesas', ab: 'RD', routeRef: '', permissionRef: 'list'},
            {path: '/purchase-order/list', title: 'Pedido de Compra', ab: 'PC', routeRef: 'purchase-order', permissionRef: 'list'},
            {path: '/pre-invoice/list', title: 'Notas de Comissão', ab: 'NC', routeRef: 'pre-invoice', permissionRef: 'list'},
        ]
    },
    {
        path: '/admin',
        title: 'Administrativo(em dev)',
        type: 'sub',
        collapse: 'administrativo',
        target: 'sales',
        icontype: 'nc-icon nc-briefcase-24',
        role: ['Admin'],
        children: [
            {path: '/fluxo', title: 'Fluxo de Aprovação', ab: 'FA'},
        ]
    },
    {
        path: '/politica-representantes',
        title: 'Política Repres.',
        type: 'link',
        icontype: 'nc-icon nc-bank',
        role: ['Admin', 'VENDEDOR']
    },

    // {
    //     path: '',
    //     title: '--------------------------------------------',
    //     type: 'sub',
    //     icontype: '',
    //     showInProduction: false
    // },
    // {
    //     path: '/components',
    //     title: 'Components',
    //     type: 'sub',
    //     collapse: 'components',
    //     target: 'componentsTarget',
    //     icontype: 'nc-icon nc-layout-11',
    //     showInProduction: false,
    //     children: [
    //         {path: 'buttons', title: 'Buttons', ab: 'B'},
    //         {path: 'grid', title: 'Grid System', ab: 'GS'},
    //         {path: 'panels', title: 'Panels', ab: 'P'},
    //         {path: 'sweet-alert', title: 'Sweet Alert', ab: 'SA'},
    //         {path: 'notifications', title: 'Notifications', ab: 'N'},
    //         {path: 'icons', title: 'Icons', ab: 'I'},
    //         {path: 'typography', title: 'Typography', ab: 'T'}
    //     ]
    // }, {
    //     path: '/forms',
    //     title: 'Forms',
    //     type: 'sub',
    //     collapse: 'forms',
    //     target: 'formTarget',
    //     showInProduction: false,
    //     icontype: 'nc-icon nc-ruler-pencil',
    //     children: [
    //         {path: 'regular', title: 'Regular Forms', ab: 'RF'},
    //         {path: 'extended', title: 'Extended Forms', ab: 'EF'},
    //         {path: 'validation', title: 'Validation Forms', ab: 'VF'},
    //         {path: 'wizard', title: 'Wizard', ab: 'W'}
    //     ]
    // }, {
    //     path: '/tables',
    //     title: 'Tables',
    //     type: 'sub',
    //     collapse: 'tables',
    //     target: 'tableTarget',
    //     showInProduction: false,
    //     icontype: 'nc-icon nc-single-copy-04',
    //     children: [
    //         {path: 'regular', title: 'Regular Tables', ab: 'RT'},
    //         {path: 'extended', title: 'Extended Tables', ab: 'ET'},
    //         {path: 'datatables.net', title: 'Datatables.net', ab: 'DT'}
    //     ]
    // }, {
    //     path: '/maps',
    //     title: 'Maps',
    //     type: 'sub',
    //     collapse: 'maps',
    //     target: 'mapsTarget',
    //     showInProduction:false,
    //     icontype: 'nc-icon nc-pin-3',
    //     children: [
    //         {path: 'google', title: 'Google Maps', ab: 'GM'},
    //         {path: 'fullscreen', title: 'Full Screen Map', ab: 'FSM'},
    //         {path: 'vector', title: 'Vector Map', ab: 'VM'}
    //     ]
    // }, {
    //     path: '/widgets',
    //     showInProduction: false,
    //     title: 'Widgets',
    //     type: 'link',
    //     icontype: 'nc-icon nc-box'

    // }, {
    //     path: '/charts',
    //     showInProduction: false,
    //     title: 'Charts',
    //     type: 'link',
    //     icontype: 'nc-icon nc-chart-bar-32'

    // }, {
    //     path: '/calendar',
    //     showInProduction: false,
    //     title: 'Calendar',
    //     type: 'link',
    //     icontype: 'nc-icon nc-calendar-60'
    // }, {
    //     path: '/pages',
    //     showInProduction: false,
    //     title: 'Pages',
    //     collapse: 'pages',
    //     type: 'sub',
    //     icontype: 'nc-icon nc-book-bookmark',
    //     children: [
    //         {path: 'timeline', title: 'Timeline Page', ab: 'T'},
    //         {path: 'user', title: 'User Page', ab: 'UP'},
    //         {path: 'login', title: 'Login Page', ab: 'LP'},
    //         {path: 'register', title: 'Register Page', ab: 'RP'},
    //         {path: 'lock', title: 'Lock Screen Page', ab: 'LSP'}
    //     ]
    // }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.css'],

})

export class SidebarComponent implements OnInit {

    userName: string;
    public menuItems: any[];
    public companyIdRef: string;
    public isProd: boolean = environment.production;
    public isClosed: boolean;
    public shouldShowitens: boolean = true;
    public ipdvUrl: string

    permissionState$ = new BehaviorSubject<any>(null);

    constructor(private sharedService: SharedDataService, private permissionService: PermissionsService, public authService: AuthService) {}
    isNotMobileMenu(): boolean {
        if ( window.outerWidth > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        this.userName = JSON.parse(localStorage.getItem('currentUser')).username

        if (this.authService.ipdvUrl === undefined) {
            this.authService.ipdvUrl = localStorage.getItem('ipdvUrl')
        }

        if ( this.permissionState$.getValue() ) {
            const permissions = this.permissionState$.getValue()
            this.handleSideMenuRender(permissions)
        } else {
            this.permissionService.getPermissions(this.handleSideMenuRender)
        }
        // const permissions = JSON.parse(localStorage.getItem('currentUser')).permissions
        // permissions.tradeneg = ['get']
        // permissions.role = 'Aprovador'
        this.sharedService.getUrlReference().subscribe(
            data => {
                this.companyIdRef = data
            }
        )
        this.verifySidebar()
    }

    handleSideMenuRender = (permissions: UserPermission) => {
        this.menuItems = ROUTES.filter(menuItem => {
            if (!this.isProd) { menuItem.role.push('VENDEDOR') }
            
            let allowedChildren = false;

            if (menuItem.children) {
                menuItem.children.map(item => {
                    item.hasPermission = permissions[menuItem.target][item.routeRef]
                    ? permissions[menuItem.target][item.routeRef].includes(item.permissionRef)
                    : item.hasPermission

                    if (item.hasPermission) {
                        allowedChildren = true
                    }

                    return item
                })
            }

            menuItem.hasPermission = menuItem.role.includes(permissions.role) && allowedChildren

            if (menuItem.title === 'Política Repres.' && permissions.A3_TPVEND === "R") {
                menuItem.hasPermission = true
            }

            return menuItem;
        })
    }

    verifySidebar(): void {
        this.sharedService.emmitSideBarClosed()
        .subscribe(isClosed => {
            this.isClosed = isClosed
            this.shouldShowitens = !isClosed;
        });
    }

    onSidebarOver(hover: boolean): void {
        if ( !this.isNotMobileMenu()) {
            if ( this.isClosed) {
                this.shouldShowitens = hover;
            }
        }
    }

}
